import Step from 'apollo-react/components/Step';
import StepLabel from 'apollo-react/components/StepLabel';
import Stepper from 'apollo-react/components/Stepper';
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams, UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import Modal from 'apollo-react/components/Modal';
import axiosInstance from "../../../../axiosInstance";
import { toast } from "react-toastify";
import makeStyles from '@mui/styles/makeStyles';
import { Form, withFormik } from 'formik';
// import Button from 'apollo-react/components/Button';
import ButtonGroup from 'apollo-react/components/ButtonGroup';
import Grid from 'apollo-react/components/Grid';
import MenuItem from 'apollo-react/components/MenuItem';
import Paper from 'apollo-react/components/Paper';
import Typography from 'apollo-react/components/Typography';
import { FormikSelect, FormikSwitch, FormikTextField, FormikDatePicker, FormikImageUploadWithPreview } from '../../../common/FormikComponent';
import LinearProgress from 'apollo-react/components/LinearProgress';
import WorkflowInit from  './builder_init';

import Sidebar from "./builder_sidebar";

import validate from './main_wizard_vaidation';
import validate_publishing from './publishing_validation';

const styles = {
  paper: { padding: '22px' },
  submit: { margin: '16px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  section: { marginBottom: 32 },
  subsection: { marginBottom: 8 },
  buttons: { width: "142px", padding: "0px", minHeight: "34px", fontWeight: '400' },
  wf_progress: { padding: '0px 0 17px 0',  width: '100%' },
  modal: { maxWidth: 980, width: "34%" }
};

const initialValues = {
  name: '',
  description: '',
  workflowTemplateId: '',
  saveAsTemplate: 0,
  versionId: '',
  workflowImage: [],
};

const useStyles = makeStyles(styles);

const steps = ['Step 1', 'Step 2'];

const handleSubmit = (values, { setSubmitting }) => {
  setTimeout(() => {
    setSubmitting(false);
  }, 400);
};



const MainWizard = ({ values, isSubmitting, content, setFieldTouched, setFieldError, resetForm, onEvent, setValues, setFieldValue }) => {
  const { wfId, vId: versionId, draftId } = useParams();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [workflowTemplates, setworkflowTemplates] = useState([]);
  const [loading, setLoading] = useState(true); 
  const workflowBuilderRef = useRef(null);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [preJsonData, setPreJsonData] = useState(false);
  const [originalName, setOriginalName] = useState("");
  const [originalPublishedAt, setOriginalPublishedAt] = useState()
  const [publishedAtValue, setPublishedAtValue] = useState(new Date()); // Format as YYYY-MM-DD
  const nextLocationRef = useRef(null);

  //For Discard prompts
  const [showCustomPrompt, setShowCustomPrompt] = useState(false);
  const [isDraftSaved, setIsDraftSaved] = useState(false);

  let navigate = useNavigate();
  
  // Handle the beforeunload event to show a browser default confirmation dialog when page manually reloaded
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Show a confirmation dialog
      event.preventDefault();
      event.returnValue = ''; // Required for some browsers to show the confirmation dialog
    };

    // Add the event listener
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      // Clean up the event listener
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Call the custom prompt for saving draft
  function useLegacyBlocker(blocker, when = true) {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
      if (!when) return;

      const push = navigator.push;

      navigator.push = (...args) => {
        // console.log("Custom navigation blocker triggered", args);
        const allow = blocker();
        if (allow) {
          push.apply(navigator, args);
        } else {
          nextLocationRef.current = args[0];
          setShowCustomPrompt(true);
        }
      };

      return () => {
        navigator.push = push;
      };
    }, [blocker, when, navigator]);
  }

  // Call the custom blocker hook
  useLegacyBlocker(
    () => {
      // Block if draft is NOT saved
      return isDraftSaved; // Only allow navigation if draft is saved
    },
    true,
    nextLocationRef,
    setShowCustomPrompt
  );
  
  // Handler for modal action yes
  const handleDiscardPromptYes = async () => {
    setShowCustomPrompt(false);
    setIsDraftSaved(true);
    await saveAsDraft("forceNavigation");
    if (nextLocationRef.current) {
      navigate(nextLocationRef.current);
      nextLocationRef.current = null;
    }
  };

  const handleCustomPromptNo = () => {
    setShowCustomPrompt(false);

    // Temporarily allow navigation
    setIsDraftSaved(true);

    // Use setTimeout to ensure state is updated before navigating
    setTimeout(() => {
        if (nextLocationRef.current) {
            navigate(nextLocationRef.current);
            nextLocationRef.current = null;
        }
        // Reset isDraftSaved after navigation
        setIsDraftSaved(false);
    }, 0);
  };

  const handleCustomPromptClose = () => {
    setShowCustomPrompt(false);
    setIsDraftSaved(false);
    // Stay on the page
  };
  
  // Set Form values
  useEffect(() => {
    if (content) {
      setLoading(true);
      setValues(content);
      setLoading(false);
    }
  }, [content, setValues]);

  // Fetch workflow version or draft data based on params
  useEffect(() => {
    // console.log("versionId:", versionId);
    // console.log("draftId:", draftId);
    // console.log("wfId:", wfId);

    // Helper to fetch and set workflow data (version or draft)
    const fetchData = async ({ url, isVersion }) => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(url);
        if (response.data) {
          console.log(isVersion ? "Workflow version data:" : "Workflow draft data:", response.data);
          
          const workflowData = isVersion ? response.data.data : response.data;
          const workflowImageId = workflowData.workflow_image_id;
          let workflowImageArray = [];

          if (workflowImageId) {
            try {
              const imageResponse = await axiosInstance.get(
                `${process.env.REACT_APP_SERVER_URL}/api/v1/files/admin/preview/${workflowImageId}`,
                { 
                  withCredentials: true,
                  responseType: 'blob'
                }
              );
              
              const blob = new Blob([imageResponse.data], { 
                type: imageResponse.headers['content-type'] || 'image/jpeg'
              });
              const url = window.URL.createObjectURL(blob);
              
              workflowImageArray = [{
                id: workflowImageId,
                preview: url,
                name: `workflow-image-${workflowImageId}`,
                size: blob.size,
                type: blob.type
              }];
            } catch (imageError) {
              console.warn('Could not load existing workflow image:', imageError);
            }
          }

          setValues({
            ...values,
            name: workflowData.name,
            description: workflowData.description,
            workflowImage: workflowImageArray,
            ...(isVersion ? { versionId: versionId } : {}),
            saveAsTemplate: 0,
          });

          if (isVersion) {
            setPublishedAtValue( new Date(workflowData.publishedAt) );
            setOriginalPublishedAt( new Date(workflowData.publishedAt) );
            setOriginalName(workflowData.name);
          }

          setPreJsonData(workflowData.stages_json);

          // Only show the toast on the initial load
          if (workflowBuilderRef.current) {
            toast.success(isVersion ? "Workflow data loaded successfully!" : "Workflow draft loaded successfully!");
            workflowBuilderRef.current = false; // Mark as no longer the initial load
          }
        } else {
          setValues(initialValues);
        }
      } catch (error) {
        console.error("Error fetching workflow data:", error);
        toast.error("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    if (versionId) {
      fetchData({ url: `/api/workflows/version/${versionId}`, isVersion: true });
    } else if (draftId) {
      fetchData({ url: `/api/workflows-drafts/${draftId}`, isVersion: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValues, versionId, draftId]);
  

  useEffect(() => {
    async function fetchTemplates() {
      setLoading(true);
      await axiosInstance.get("/api/workflows-template").then((response) => {
        setworkflowTemplates(response.data);
        setLoading(false);
      });
    }
    fetchTemplates();
  }, []);

  // Function to handle template selection populate it's data on form
  const handleTemplateSelection = async (templateId) => {
    if (templateId) {
      // Find the selected template data
      const selectedTemplate = workflowTemplates.find(
        (template) => template.id === templateId
      );

      if (selectedTemplate) {
        // Populate the form fields with the selected template's data
        setValues((prevValues) => ({
          ...prevValues,
           workflowTemplateId: selectedTemplate.id || "",
        }))

        setPreJsonData(selectedTemplate.stages_json);

        toast.success("Template data loaded successfully!");
      }
    }
  };

  // Handle save workflow from template or draft
  const handleWorkflowSave = async ({ method, url, successMessage, dataPrepared, source }) => {
  if (!dataPrepared) {
    toast.error("There is something wrong with template data.");
    return;
  }

  try {
    await axiosInstance[method](url, dataPrepared, { withCredentials: true });
    toast.success(successMessage);

    // Only navigate if not forceNavigation
    if (source !== 'forceNavigation') {
      navigate(-1);
    }
    // If forceNavigation, navigation will be handled by pendingTx.retry() in handleDiscardPromptYes
  } catch (err) {
    console.error("Error in save workflow:", err);
    
    // Extract and display specific error messages from backend
    if (err.response && err.response.data) {
      const errorData = err.response.data;
      
      // Handle array of error objects
      if (Array.isArray(errorData.errors)) {
        errorData.errors.forEach(error => {
          toast.error(error.message || error);
        });
      } 
      // Handle string error message
      else if (errorData.errors) {
        toast.error(errorData.errors);
      }
      // Handle top-level message
      else if (errorData.message) {
        toast.error(errorData.message);
      }
      // Fallback
      else {
        toast.error("An unexpected error occurred while saving the workflow.");
      }
    } else {
      toast.error("An unexpected error occurred while saving the workflow.");
    }
  }
};

  // Handle workflow template submission
  const submitSaveAsTemplate = async () => {
    await handleWorkflowSave({
      method: 'post',
      url: `${process.env.REACT_APP_SERVER_URL}/api/workflows-template`,
      successMessage: 'Workflow saved as template successfully!',
      dataPrepared: prepareData(),
      source: 'button'
    });
  }

  // Handle save as draft to save the workflow data in localStorage
  const saveAsDraft = async (source) => {
    if (versionId) {
      setValues({
          ...values,
          versionId: versionId,
        });
    }

    const isUpdate = Boolean(draftId);
    await handleWorkflowSave({
      method: isUpdate ? 'put' : 'post',
      url: isUpdate
        ? `${process.env.REACT_APP_SERVER_URL}/api/workflows-drafts/${draftId}`
        : `${process.env.REACT_APP_SERVER_URL}/api/workflows-drafts`,
      successMessage: isUpdate
        ? 'Workflow draft updated successfully!'
        : 'Workflow draft saved successfully!',
      dataPrepared: prepareData(),
      source
    });
  };

  const prepareData = () => {
    let workflowJson;
    // Case navigated to another menu item "Draft prompt appears"
    if (!workflowBuilderRef.current) {
      if(preJsonData) {
        workflowJson = typeof preJsonData === 'string' ? JSON.parse(preJsonData) : preJsonData;
      } else {
        // Default minimal workflow JSON if builder is not initialized
        workflowJson = {
          nodes: [
            {
              id: "start",
              type: "input",
              data: {
                name: "Start Flow",
              },
              category: "Start",
              position: { x: 350, y: 150 },
            },
          ],
          edges: [],
        };
      }
    } else {
      const jsonData = workflowBuilderRef.current.getWorkflowJsonData();
      if (!jsonData) {
        toast.error("Workflow data is invalid or empty.");
        return null;
      }

      // Sanitize nodes: remove JSX labels and keep only serializable data
      const sanitizedNodes = jsonData.nodes.map(node => {
        const { data, ...rest } = node;
        // Remove JSX label but keep other data properties
        const { label, ...cleanData } = data || {};
        return {
          ...rest,
          data: cleanData,
        };
      });

      workflowJson = {
        ...jsonData,
        nodes: sanitizedNodes,
      };
    }
    
    // Extract workflow image ID from uploaded files (preserves existing or uses new upload)
    const workflowImageId = values.workflowImage && values.workflowImage.length > 0 
      ? values.workflowImage[0].id 
      : null;
    
    // Exclude large image data from payload to prevent 413 error
    const { workflowImage, ...dataWithoutImage } = values;
    
    return {
      ...dataWithoutImage,
      stages_json: JSON.stringify(workflowJson),
      published: 1,
      publishedAt: publishedAtValue,
      workflow_image_id: workflowImageId
    };
  }

  const handleBackStep = () => {
    // Get current workflow Json data from WorkflowBuilder to send it back when go forewoard to the next step
    const jsonData = workflowBuilderRef.current.getWorkflowJsonData();
    if (jsonData) {
      setPreJsonData(jsonData);
    }
    setActiveStep(activeStep - 1);
  };

  const handleNextStep = async (validate, values) => {
    const errors = await validate(values); // Validate all fields
  
    // Mark all fields as touched and set their errors
    Object.keys(values).forEach((field) => {
      setFieldTouched(field, true, false); // Mark the field as touched
      setFieldError(field, errors[field] || ''); // Set the error or clear it if no error exists
    });
  
    // Proceed to the next step only if there are no errors
    if (Object.keys(errors).length === 0) {
      setActiveStep(activeStep + 1);
    }
  };

  // Discard Modal and confirmation
  const handleDiscardOpen = () => {
    setShowDiscardModal(true);
  };
  
  const handleDiscardClose = () => {
    setShowDiscardModal(false);
  };

  const confirmDiscard = (resetForm) => {
    resetForm();

    // Reset the workflowBuilderRef in builder_container component
    if (workflowBuilderRef.current) {
      workflowBuilderRef.current.resetWorkflow();
      toast.success("Workflow data discarded successfully!");

      navigate(-1);
    }

    setShowDiscardModal(false);
  };


  const dataPublishingValidation = async () => {
    if (workflowBuilderRef.current) {
      // Get the workflow Json data from WorkflowBuilder
      const jsonData = workflowBuilderRef.current.getWorkflowJsonData();

      // Validate the workflow Json data
      const errors = await validate_publishing(jsonData);
      
      if (Object.keys(errors).length > 0) {
        toast.warning(errors.message || "Validation failed. Please fix the issues before publishing.");
        return false;
      } else if(versionId && new Date() >= originalPublishedAt) {
        if (originalName === values.name) {
          // Handle in case creating new version after checking publishAt values
          toast.warning("Please change Workflow name to create a new version.");
          return false;
        }
        
        // Add current date to the publishedAt value in modal
        setPublishedAtValue(new Date());
      }
    } else {
      toast.warning("Workflow data is not available. Please ensure the workflow is created before publishing.");
      return false;
    }

    toast.success("Workflow provided is valid");
    return true;
  };

  // Handle opening publish modal (DateTime)
  const handlePublishOpen = async () => {
    const isValid = await dataPublishingValidation();
    if (isValid) {
      setShowPublishModal(true);
    }
    //  else {
    //   toast.warning("Please ensure that the workflow is correct.");
    // }
  };

  const confirmPublish = async () => {
    if (!workflowBuilderRef.current) {
      toast.warning("Please ensure the workflow is created before publishing.");
      return;
    }

    const dataPrepared = prepareData();
    if (!dataPrepared) {
      toast.warning("Something went wrong with data");
      return;
    }

    try {
      let response;
      
      if(versionId && new Date() < originalPublishedAt) {
        response = await axiosInstance.put( `${process.env.REACT_APP_SERVER_URL}/api/workflows/${wfId}/version/${versionId}`, dataPrepared, { withCredentials: true } );
      } else if (!wfId) {
       response =  await axiosInstance.post( `${process.env.REACT_APP_SERVER_URL}/api/workflows`, dataPrepared, { withCredentials: true } );
      } else {
        response = await axiosInstance.post( `${process.env.REACT_APP_SERVER_URL}/api/workflows/${wfId}/version`, dataPrepared, { withCredentials: true } );
      }

      // If the workflow is saved as a template, delete the draft if exists
      if (response && draftId) {
        await axiosInstance.delete(`${process.env.REACT_APP_SERVER_URL}/api/workflows-drafts/${draftId}`, { withCredentials: true });
      }
      
      navigate(-1);

      // Handle success response
      toast.success('Workflow published successfully!');
    } catch (err) {
      console.error("Error in handleCreateAndUpdate:", err);
  
      // Handle errors from the response
      if (err.response?.data?.errors) {
        Object.entries(err.response.data.errors).forEach(([key, value]) => {
          // console.error(`Error in ${key}: ${value}`);
          toast.error(`Error in ${key}: ${value}`);
        });
      } else {
        // Handle unexpected errors
        toast.error("An unexpected error occurred while publishing workflow.");
      }
    }

    setShowPublishModal(false);

    // console.log('combinedData: ----->', dataPrepared);
  };
  
  const handlePublishClose = () => {
    setShowPublishModal(false);
  };
  
  // End of Discard Modal and confirmation

  return (
    <>
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Stepper box activeStep={activeStep}>
          {steps.map((label) => (
            <Step key={label} style={{ border: 'none' }}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {activeStep === steps.length - 1 ? (
          <Sidebar />
        ) : ("")}
        
      </Grid>

      <Grid item xs={12} md={9}>
        <div className={classes.wf_progress}>
          <LinearProgress variant="determinate" className={'progress-bar-workflow'} value={activeStep !== steps.length - 1 ? (50) : (100)} />
        </div>

        {loading ? (
        <Typography variant="body2" style={{ margin: '8px 0' }}>
        {'Loading...'}
        </Typography>
        ) : (
          <Form noValidate>
            
              {activeStep !== steps.length - 1 ? (
                // Step 1
                <div className={classes.section}>
                  <Paper className={classes.paper}>
                    <FormikTextField fullWidth name="name" label="Workflow Name" required />

                    <FormikImageUploadWithPreview
                      name="workflowImage"
                      label="Upload Image"
                      helperText="Max 5MB, images only"
                      accept=".jpg,.jpeg,.png,.gif"
                      isAdminUpload={true}
                      required={false}
                    />

                    <FormikTextField fullWidth name="description" label="Description" multiline/>

                    <input type="hidden" name="versionId" value={versionId} />

                    <FormikSelect
                      name="workflowTemplateId"
                      label="Select Workflow Template"
                      fullWidth
                      onChange={(e) => {
                        const selectedTemplateId = e.target.value;
                        handleTemplateSelection(selectedTemplateId); // Call the function to fetch and populate data
                      }}
                    >
                      <MenuItem value="">{'Select a Workflow Template'}</MenuItem>
                      {workflowTemplates?.map((wf_template) => (
                        <MenuItem key={wf_template.id} value={wf_template.id}>
                          {wf_template.name}
                        </MenuItem>
                      ))}
                    </FormikSelect>

                    <FormikSwitch
                      checked={values.saveAsTemplate === 1}
                      onChange={(e) => {
                        setFieldValue("saveAsTemplate", e.target.checked ? 1 : 0); // Update only the saveAsTemplate field
                      }}
                      name="saveAsTemplate"
                      label="Save as Template"
                    />
                  </Paper>

                  <ButtonGroup alignItems="right" style={{ marginTop: '16px' }}
                    buttonProps={[
                      {
                        variant: 'secondary',
                        label: 'Previous',
                        onClick: handleBackStep,
                        disabled: true,
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: 'Discard',
                        status: 'danger',
                        onClick: () => handleDiscardOpen('warning'),
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: 'Next',
                        onClick: () => handleNextStep(validate, values, setFieldTouched, setFieldError),
                        type: 'button',
                        className: classes.buttons
                      },
                    ]}
                  />

                </div>
              ) : activeStep !== steps.length ? (
                // Step 2
                
                <div style={{ marginTop: 16 }}>
                  <Paper className={classes.paper}>
                    <WorkflowInit ref={workflowBuilderRef} preJsonData={preJsonData}  />
                  </Paper>

                  <ButtonGroup alignItems="right" style={{ marginTop: '16px' }}
                    buttonProps={[
                      {
                        variant: 'secondary',
                        label: 'Previous',
                        onClick: handleBackStep,
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: 'Discard',
                        status: 'danger',
                        onClick: () => handleDiscardOpen('warning'),
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: 'Validate',
                        onClick: dataPublishingValidation,
                        type: 'button',
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: 'Save as Draft',
                        onClick: () => saveAsDraft('button'),
                        type: 'button',
                        className: classes.buttons
                      },
                      {
                        variant: 'primary',
                        label: values.saveAsTemplate === 0 ? 'Publish' : 'Save',
                        onClick: () => values.saveAsTemplate === 0 ? handlePublishOpen('custom') : submitSaveAsTemplate('custom'),
                        type: 'button',
                        className: classes.buttons
                      },
                    ]}
                  />

                </div>
              ) : (
                // All steps completed
                <div>
                  <Typography variant="body2" style={{ margin: '8px 0' }}>
                    {'All steps completed!'}
                  </Typography>
                </div>
              )}
          </Form>
          )}

      </Grid>
      
    </Grid>

    
    <Modal
        open={showDiscardModal}
        variant="warning"
        title={"Confirm Discard"}
        message={'Are you sure you want to discard all data?'}
        onClose={() => handleDiscardClose() }
        buttonProps={[
            { label: 'Go Back', onClick: handleDiscardClose },
            { label: 'Confirm', onClick: () => confirmDiscard(resetForm) }
        ]}
        id="warning"
    />

      {/* Custom navigation prompt modal */}
      <Modal
        open={showCustomPrompt}
        variant="warning"
        title="Unsaved Changes"
        message="Do you want to save changes as draft?"
        onClose={handleCustomPromptClose}
        buttonProps={[
          { label: "Discard", onClick: handleCustomPromptNo, status: "danger" },
          { label: "Save and navigate", onClick: handleDiscardPromptYes }
        ]}
        id="custom-prompt"
      />

      {/* Publish Modal */}
    <Modal
        open={showPublishModal}
        variant="success"
        title={"Confirm Publish"}
        className={classes.modal}
        id="success"
        onClose={() => handlePublishClose()}
        buttonProps={[
          { label: 'Go Back', onClick: handlePublishClose },
          { label: 'Publish', onClick: () => confirmPublish() }
        ]}
      >
          <FormikDatePicker
          dateFormat="DD/MM/YYYY"
          fullWidth name="publishedAt"
          defaultValue={publishedAtValue}
          placeholder="dd/mm/yyyy"
          label="Date:"
          disablePast
          required
          onChange={(date) => {
            setFieldValue("publishedAt", date);
            setPublishedAtValue(date);
          }}
          />
      </Modal>
    </>
  );
};

export default withFormik({
  validate,
  mapPropsToValues: () => initialValues,
  handleSubmit,
  validateOnChange: false, // Disable validation on input change
  validateOnBlur: false,   // Disable validation on blur
})(MainWizard);